<template>
  <v-flex id="mobile_bar" class="hidden-md-and-up v-footer--fixed">
    <v-layout row class="text-xs-center">
      <!--
      <v-flex @click="findRoom()">
        <div class="mobile-bar-icon">
          <div class="cate-icon svg-wrap">
            <canvas height="1" width="3"></canvas>
            <icon-home/>
          </div>
          <div class="cate-name">
            방찾아주세요
          </div>
        </div>
      </v-flex>
      -->
      <v-flex>
        <router-link tag="div" :to="{ path: 'modal', query: { receipt: 1 }}" class="mobile-bar-icon">
          <div class="cate-icon svg-wrap">
            <canvas height="1" width="3"></canvas>
            <icon-home/>
          </div>
          <div class="cate-name">
            방내놔요
          </div>
        </router-link>
      </v-flex>
      <v-flex>
        <div @click="mapData.favoriteView.show = true" class="mobile-bar-icon">
          <div class="cate-icon svg-wrap">
            <canvas height="1" width="3"></canvas>
            <icon-bookmark/>
          </div>
          <div class="cate-name">
            찜한매물
          </div>
        </div>
      </v-flex>
      <v-flex>
        <router-link tag="div" to="/map" class="mobile-bar-icon">
          <div class="cate-icon svg-wrap">
            <canvas height="1" width="3"></canvas>
            <icon-map/>
          </div>
          <div class="cate-name">
            방찾기
          </div>
        </router-link>
      </v-flex>
      <v-flex>
        <router-link tag="div" to="/review" class="mobile-bar-icon">
          <div class="cate-icon svg-wrap">
            <canvas height="1" width="3"></canvas>
            <icon-inquiry/>
          </div>
          <div class="cate-name">
            고객리뷰
          </div>
        </router-link>
      </v-flex>
      <v-flex>
        <router-link tag="div" to="/more" class="mobile-bar-icon">
          <div class="cate-icon svg-wrap">
            <canvas height="1" width="3"></canvas>
            <icon-more/>
          </div>
          <div class="cate-name">
            더보기
          </div>
        </router-link>
      </v-flex>
    </v-layout>
  </v-flex>
</template>

<script>
import IconHome from '../svg/MobileBarHome'
import IconBookmark from '../svg/MobileBarBookmark'
import IconMap from '../svg/MobileBarMap'
import IconInquiry from '../svg/MobileBarInquiry'
import IconMore from '../svg/MobileBarMore'
import EventBus from '@/utile/eventBus'

import { mapState } from 'vuex'
//
export default {
  components: {
    IconHome,
    IconBookmark,
    IconMap,
    IconInquiry,
    IconMore
  },
  computed: {
    ...mapState({
      mapData: state => state.mapData,
      board: state => state.board,
      manager: state => state.manager
    })
  },
  methods: {
    findRoom: () => {
      EventBus.$emit('findRoom', 0)
    },
    showItemReceipt () {
      if (this.auth.isAuth) {
        this.board.itemReceipt.show = true
      } else {
        this.auth.modal.login = true
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/layout/MobileBar.vue